module.exports = __webpack_public_path__ + "media/images/camden_new-1769c10b.jpg";